import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useEffect, useState } from 'react';
import { useTheme } from 'styled-components';
import { useWindowSize } from '@miro-site/core';
import Desktop from './components/Desktop';
import Mobile from './components/Mobile';
import { jsx as _jsx } from "react/jsx-runtime";
var CategoryNav = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _useState = useState(false),
      isMounted = _useState[0],
      setMounted = _useState[1];

  var theme = useTheme();
  var windowSize = useWindowSize();
  var isMobileViewPort = windowSize.width && windowSize.width < theme.breakpoints.small;
  useEffect(function () {
    setMounted(true);
  }, []);

  if (!isMounted) {
    return null;
  }

  if (isMobileViewPort) {
    return /*#__PURE__*/_jsx(Mobile, _objectSpread({
      ref: ref
    }, props));
  }

  return /*#__PURE__*/_jsx(Desktop, _objectSpread({
    ref: ref
  }, props));
});
CategoryNav.displayName = 'CategoryNav';
export default CategoryNav;
export { default as Button } from './components/Button';